<div class="clearfix file-uploader">
    <input
        type="hidden"
        [formControl]="formControl"
        [formlyAttributes]="field"
        [(ngModel)]="imageUrlModel"
    />
    <p-fileUpload
        name="files[]"
        #uploader
        [disabled]="to.disabled || uploader.progress != 0"
        [url]="to.url || to.baseUrl + '?folder=' + to.path"
        [accept]="to.accept"
        (onUpload)="process($event)"
        (onBeforeUpload)="beforeUpload($event)"
        (onError)="errorDuringUploading($event)"
        [multiple]="to.multiple"
        [hidden]="to.showTable == true && to.disabled == true"
        [chooseLabel]="to.chooseLabel == null ? 'Add Files' : to.chooseLabel"
        [auto]="true"
        [styleClass]="to.styleClass"
    >
        <ng-template pTemplate="content">
            <div class="hidden-mobile" *ngIf="to.dropMessage">
                {{ to.dropMessage }}
            </div>
            <div class="hidden-mobile" *ngIf="!to.dropMessage">
                Drop your files here
            </div>
        </ng-template>
    </p-fileUpload>
    <div *ngIf="to.description">
        <small class="text-muted">
            {{ to.description }}
        </small>
    </div>
    <ng-container *ngIf="to.showTable == true">
        <div *ngIf="!to.disabled" class="clearfix"></div>
        <strong *ngIf="to.tableHeader">{{ to.tableHeader }}</strong>
        <data-table
            [dataset]="
                (to.tableEntities || []).length > 0
                    ? to.tableEntities
                    : model['' + key] || []
            "
            [class]="to.tableClass ? to.tableClass : 'override-height'"
            [addThumbnailPrefix]="true"
            [openImageInNewWindow]="to.openImageInNewWindow"
            [emptyMessageString]="getEmptyMessageString()"
            [rowsPerPage]="to.rowsPerPage || [10, 25, 50]"
            [rowsToDisplay]="to.rowsToDisplay || 10"
            [scrollable]="to.scrollable == false ? false : true"
            [showExport]="false"
            [hideSelectAll]="to.hideSelectAll"
            (onImageUpdated)="onImageUpdated($event)"
            [loading]="to.loading"
        >
            <ng-container *ngFor="let column of to.tableColumns">
                <column
                    *ngIf="
                        (column.hasOptions && to.disabled != true) ||
                        !column.hasOptions
                    "
                    [value]="column.value"
                    [type]="column.type"
                    [filterable]="column.filterable"
                    [header]="column.header"
                    [sortable]="column.sortable"
                    [width]="column.width"
                    [disableCheck]="column.disableCheck"
                    [editable]="column.editable && to.disabled != true"
                    [options]="
                        column.hasOptions == true
                            ? column.options || 'options'
                            : null
                    "
                    [linkName]="column.linkName"
                    [format]="column.format"
                >
                </column>
            </ng-container>
        </data-table>
        <div class="clearfix"></div>
    </ng-container>
</div>
